document.addEventListener("DOMContentLoaded", () => {
    // automatical add wrapper for custom video btn
    const videoElements = document.querySelectorAll('.section-hero-single-blog .html5_video_players:not(.wrapped)');

    videoElements.forEach(video => {
        if (!video.parentElement.classList.contains('video-container')) {
            const videoContainer = document.createElement('div');
            videoContainer.classList.add('video-container');
            video.parentNode.insertBefore(videoContainer, video);
            videoContainer.appendChild(video);
            video.classList.add('wrapped');
        }
    });

    // add custom btn
    setTimeout(() => {
        const videoContainers = document.querySelectorAll('.section-hero-single-blog .video-container');

        videoContainers.forEach(container => {
            container.insertAdjacentHTML('afterbegin', `
                  <div class="wrap-go-down-btn">
                  <div class="go-down-btn">
                    <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="150px"
                            height="150px"
                            viewBox="0 0 100 100"
                            enable-background="new 0 0 100 100"
                            xml:space="preserve"
                    >

                        <g transform="scale(0.64) translate(0, 0)">
                            <path
                                     class="circle-bg" d="M132.388 77.2652C131.532 56.6265 128.261 50.0778 114.343 35.3495C101.627 21.8938 70.0165 24.4352 54.567 30.0813C48.6193 32.2532 45.6521 35.8317 40.0556 40.7048C36.3966 43.8909 33.2638 47.7533 31.8818 52.4041C27.5281 67.0542 27.1283 81.1935 31.1309 96.227C33.8113 106.294 36.7044 111.44 45.949 118.524C47.4101 119.643 49.0223 120.557 50.7315 121.24C63.2658 126.251 79.4625 129.987 92.0135 128.912C104.473 127.844 110.537 121.933 119.153 111.837C124.756 105.272 132.725 85.3855 132.388 77.2652Z"
                                    fill="#3D6124"
                            ></path>
                            <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M69.3357 61.3176C69.84 61.0422 70.4544 61.0642 70.9378 61.375L92.9289 75.5121C93.3785 75.8011 93.6502 76.2989 93.6502 76.8334C93.6502 77.3679 93.3785 77.8657 92.9289 78.1547L70.9378 92.2918C70.4544 92.6026 69.84 92.6246 69.3357 92.3492C68.8313 92.0739 68.5176 91.5451 68.5176 90.9705V62.6963C68.5176 62.1217 68.8313 61.5929 69.3357 61.3176ZM71.6592 65.5734V88.0933L89.1746 76.8334L71.6592 65.5734Z"
                                    fill="#C7E500"
                            ></path>
                            <circle
                                    cx="80"
                                    cy="76.8901"
                                    r="47.5"
                                    stroke="#C7E500"
                                    stroke-width="2"
                                    stroke-dasharray="2 4"
                                    fill="transparent"
                            ></circle>
                        </g>
 <path id="textPath" fill="none"
                              d="M89.322,50.197c0,22.09-17.91,40-40,40c-22.089,0-40-17.91-40-40 c0-22.089,17.911-40,40-40C71.412,10.197,89.322,28.108,89.322,50.197z"/>

                        <text>
                            <textPath xlink:href="#textPath">
                                <tspan x="10">Watch the</tspan>
                                <tspan x="47" dx="33">video -</tspan>
                                <tspan x="77" dx="60">Watch the</tspan>
                                <tspan x="107" dx="99">video -</tspan>
                            </textPath>
                        </text>
</svg>
                </div>
                </div>
                `);

            const goDownBtn = container.querySelector('.go-down-btn');
            const videoElement = container.querySelector('video');

            if (goDownBtn && videoElement) {
                goDownBtn.addEventListener('click', () => {
                    if (videoElement.paused || videoElement.ended) {
                        videoElement.play();
                    }
                });

                // hide button when playing video
                videoElement.addEventListener('play', () => {
                    goDownBtn.style.display = 'none';
                });

                // show button if video is paused
                videoElement.addEventListener('pause', () => {
                    if (!videoElement.seeking) {
                        goDownBtn.style.display = 'block';
                    }
                });

                // show button if video ends
                videoElement.addEventListener('ended', () => {
                    goDownBtn.style.display = 'block';
                });

                videoElement.addEventListener('seeking', () => {
                    goDownBtn.style.display = 'none';
                });

                // Show button only if video is still paused after seeking
                videoElement.addEventListener('seeked', () => {
                    if (videoElement.paused) {
                        goDownBtn.style.display = 'block';
                    }
                });
            }
        });
    }, 1000);
});